module.exports = __webpack_public_path__ + "static/media/tips_img.f9887210.svg";